// Wording + small helpers shared by the Care Team panel, bulk dialog and nurse Patients tab.
export const SLOT_LABELS = { rpm: 'RPM nurse', ccm: 'CCM nurse', both: 'RPM + CCM nurse', provider: 'Provider' };
export const CHOOSE_PLACEHOLDERS = { rpm: 'Choose RPM nurse…', ccm: 'Choose CCM nurse…', provider: 'Choose provider…' };

export const assignConfirmText = ({ fromName, toName, slotLabel, patientName }) =>
    fromName
        ? `Replace ${fromName} with ${toName} as ${slotLabel} for ${patientName}?`
        : `Assign ${toName} as ${slotLabel} for ${patientName}?`;

export const removeConfirmText = ({ fromName, slotLabel, patientName }) =>
    `Remove ${fromName} as ${slotLabel} for ${patientName}?`;

/** "Same nurse for both": one sentence covering what happens to each slot. */
export const sameForBothText = ({ toName, rpm, ccm, patientName }) => {
    const replaced = [
        rpm && rpm.id !== undefined && rpm.name && rpm.name !== toName ? `${rpm.name} as RPM nurse` : null,
        ccm && ccm.name && ccm.name !== toName ? `${ccm.name} as CCM nurse` : null,
    ].filter(Boolean);
    return `Make ${toName} the RPM and CCM nurse for ${patientName}?${replaced.length ? ` This replaces ${replaced.join(' and ')}.` : ''}`;
};

export const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

export const idOf = (v) => {
    if (!v) return '';
    if (typeof v === 'object') return String(v._id || v.id || '');
    return String(v);
};

export const CARE_TEAM_FILTERS = [
    { value: '', label: 'All care teams' },
    { value: 'noRpm', label: 'No RPM nurse' },
    { value: 'noCcm', label: 'No CCM nurse' },
];

/** Client-side list filter: '' | 'noRpm' | 'noCcm' | 'nurse:<id>' (either nurse slot). */
export const applyCareTeamFilter = (rows, filter) => {
    if (!filter) return rows || [];
    return (rows || []).filter((p) => {
        if (filter === 'noRpm') return !idOf(p?.assigned_hr_id);
        if (filter === 'noCcm') return !idOf(p?.assigned_ccm_nurse_id);
        if (filter.startsWith('nurse:')) {
            const id = filter.slice(6);
            return idOf(p?.assigned_hr_id) === id || idOf(p?.assigned_ccm_nurse_id) === id;
        }
        return true;
    });
};

export const slotBadges = (slots) => (slots || []).map((s) => (s === 'rpm' ? 'RPM' : 'CCM'));
